<template>
  <b-modal
    id="item-details-modal"
    size="xl"
    centered
    scrollable
    title="Detalhes do item"
    header-bg-variant="info"
    footer-border-variant="info"
    v-model="show"
    :hide-footer="true"
    @shown="onShown"
  >
    <item-show
      ref="itemShow"
      :isModal="true"
    />
  </b-modal>
</template>

<script>
import ItemShow from '@/views/warehouse/item/show';

export default {
  components: {
    ItemShow
  },

  data() {
    return {
      show: false,
      itemId: null
    };
  },

  mounted() {
    this.$root.$on('open-item-details', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-item-details', this.open);
  },

  methods: {
    open(itemId) {
      this.itemId = itemId;
      this.show = true;
    },

    onShown() {
      const savedTab = localStorage.getItem('item-show-active-tab');

      if (savedTab !== null) {
        this.$refs.itemShow.tabIndex = parseInt(savedTab);
      }

      this.$refs.itemShow.findItem(this.itemId);
    }
  }
}
</script>
